import { Directive, Injector, Input } from '@angular/core';
import { FormComponentSuperclass } from '@sama/ng-core';

@Directive()
export abstract class AbstractFormControl<
  T,
> extends FormComponentSuperclass<T> {
  /** use this or [disabled], not both */
  @Input() disable: string | false = false;

  constructor(injector: Injector) {
    super(injector);
    this.subscribeTo(this.getInput$('disable'), (disable) => {
      this.setDisabledState(!!disable);
    });
  }
}
